import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import AlertTriangleLarge from "../../../assets/Alarms/alert-triangle-green-large.svg";
import PageLoading from "../../../components/PageLoading/";
import { AlarmPageStrings } from "../../../constants/constantStrings";
import { extractSystemId } from "../../../utils/utils.js";
import AlarmCard from "../../SystemsAndAlarms/AlarmCard.jsx";
import "../index.css";

const ActiveAlarms = ({ setActiveAlarmCount }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeAlarms, setActiveAlarms] = useState([]);
  const allAlarms = useSelector(state => state.poll.activeAlarms);
  const currentSystemId = extractSystemId();

  const filterActiveAlarms = useCallback(() => {
    const systemsActiveAlarms = allAlarms.filter(alarm => alarm.sysId.toLowerCase() === currentSystemId.toLowerCase());
    setActiveAlarms(systemsActiveAlarms);
    setIsLoaded(true);
    setActiveAlarmCount(systemsActiveAlarms?.length);
  }, [currentSystemId]);

  useEffect(() => filterActiveAlarms(), [filterActiveAlarms]);

  return (
    <div className={"alarms__page marginBtm10"}>
      {!isLoaded && <PageLoading customHeight={"calc(100vh - 150px)"} />}

      {isLoaded && activeAlarms.length > 0 ? (
        <div className="margin-top-20">
          <div className="d-flex flex-wrap marginTop30">
            {activeAlarms.map(item => (
              <AlarmCard key={item.alarmId} {...item} />
            ))}
          </div>
        </div>
      ) : (
        <div className="no-alarm ">
          <img src={AlertTriangleLarge} alt="no-alarm" />
          <span className="bodyMainHeadingText text-center">{AlarmPageStrings.noAlarms}</span>
          <span className="smalldescriptionText width-40 ">{AlarmPageStrings.noAlarmsDescription}</span>
        </div>
      )}
    </div>
  );
};

export default ActiveAlarms;
